import { Navigate } from "react-router-dom";
import { firebaseAuth } from "@/shared/integrations/firebase/client";
import { useAuth } from "@/shared/hooks/useAuth";
import { LandingHeader } from "@/features/auth/components/LandingHeader";
import { LandingHero } from "@/features/auth/components/LandingHero";
import { LandingFeatures } from "@/features/auth/components/LandingFeatures";
import { LandingStats } from "@/features/auth/components/LandingStats";
import { LandingPricing } from "@/features/auth/components/LandingPricing";
import { LandingFooter } from "@/features/auth/components/LandingFooter";

const Index = () => {
  const { loading } = useAuth();
  const isAuthenticated = firebaseAuth?.currentUser !== null;

  if (!loading && !isAuthenticated) {
    // Demo auto-sign-in is disabled for go-live — do NOT auto sign in to the demo
    // account. Unauthenticated visitors go to the sign-in page; /demo stays
    // reachable for manual/demo use.
    return <Navigate to="/signin" replace />;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <LandingHero />
      <LandingStats />
      <LandingFeatures />
      <LandingPricing />
      <LandingFooter />
    </div>
  );
};

export default Index;
